

import React, { useEffect, useState, useMemo } from "react";
import "./styles.scss";
import { Col, Container, Row } from "react-bootstrap";
import { IoNewspaperOutline } from "react-icons/io5";

import Header from "../../component/header";
import SubHeader from "./subHeader";
import Footer from "../../component/footer/footer";

import { API } from "../../Config/API";
import { POST } from "../../utils/apiCalls";
import moment from "moment";

import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppSelector } from "../../redux/hooks";
import img1 from "../../asset/images/dummy-img.jpg";

function Homescreen() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const format = "YYYY-MM-DD";
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const date = searchParams.get("date");
  const edition = searchParams.get("edition");

  // Sort data by latest date first
  const sortedData = useMemo(() => {
    if (!data || data.length === 0) return [];

    return [...data].sort((a: any, b: any) => {
      return moment(b.date).diff(moment(a.date));
    });
  }, [data]);

  useEffect(() => {
    let obj = {
      type: "all",
      edition: edition,
      limit: 20,
      createdAt: moment(new Date()).format("YYYY-MM-DD"),
    };
    if (edition) {
    } else {
      loadData(obj);
    }
  }, []);

  useEffect(() => {
    const dates = searchParams.get("date");
    const editions = searchParams.get("edition");
    if (dates || editions) {
      let obj = {
        type: "all",
        edition: editions,
        limit: 20,
        // createdAt: dates,
        createdAt: dates ? moment(dates).subtract(1, "day").format("YYYY-MM-DD") : undefined,
      };
      loadData(obj);
    }
  }, [searchParams]);

  const loadData = async (obj: any) => {
    try {
      setIsLoading(true);
      let url = API.EPAPER;
      const response: any = await POST(url, obj);

      if (response?.length) {
        const filtered = response.filter(
          (item: any) => item.publishedAt !== null
        );
        setData(filtered);
      } else {
        setData([]);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  const getImageURL = (item: any) => {
    if (item?.image) {
      return item.image;
    }

    if (item?.epapercollections && item.epapercollections.length > 0) {
      const pages = [...item.epapercollections].sort(
        (a, b) => (a.index || 0) - (b.index || 0)
      );

      if (pages[0]?.imageUrl) {
        return pages[0].imageUrl;
      }
    }

    return "/default-epaper-thumbnail.jpg";
  };

  const handleClick = (item: any) => {
    navigate(
      `/details/${item?.edition}/${moment(item?.date).format(format)}/1/${item?.id}`,
      { state: { newspaperData: item } }
    );
  };

  return (
    <div>
      <Header onChange={(val: any) => loadData(val)} />
      <SubHeader
        edition={edition}
        date={date ? date : moment(new Date()).format("YYYY-MM-DD")}
      />
      <div className="Homescreen-box">
        <Container>
          <br />
          <div className="Homescreen-txt1">
            {edition ? edition + " Edition" : "Main Editions"}
          </div>
          {isLoading ? (
            <div className="Homescreen-loading">Loading . . .</div>
          ) : sortedData?.length ? (
            <Row>
              {sortedData?.map((item: any) => {
                const imageURL = getImageURL(item);

                return (
                  <Col sm={3} key={item?.id} onClick={() => handleClick(item)}>
                    <div className="Homescreen-item">
                      <div className="Homescreen-itemBox">
                        <img
                          src={imageURL}
                          className="Homescreen-itemImg"
                          alt={`${item?.edition} E-paper`}
                          onError={(e) => {
                            const target = e.target as HTMLImageElement;
                            target.src = img1;
                            target.onerror = null;
                          }}
                        />
                      </div>

                      <div className="Homescreen-itemBox2">
                        <div>
                          {item?.edition} -
                          {moment(item?.date).format("DD-MM-yyyy")}
                        </div>
                      </div>
                    </div>
                  </Col>
                );
              })}
            </Row>
          ) : (
            <div className="Homescreen-loading">
              <IoNewspaperOutline size={50} color="grey" />
              <div style={{ margin: 10 }} />
              <div>Sorry Epaper not found</div>
            </div>
          )}
        </Container>
      </div>
      <Footer />
    </div>
  );
}

export default Homescreen;
